module.exports = __webpack_public_path__ + "assets/images/icon_green.46b0617f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/icon_green.png
// module id = 743
// module chunks = 1